import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { ProspectFacilityDto } from '@ups/xplat/api/dto';

/**
 * US 36008: prospect sites for the facility picker, from the Sparta API (company-scoped, open
 * prospects only, never a head office; 404 until Settings:ProspectFacilityPickerEnabled). Only
 * the shared facility typeahead calls it, and only when its `includeProspectFacilities` option is set.
 */
@Injectable({
  providedIn: 'root',
})
export class SearchProspectFacilityService {
  private readonly http: HttpClient = inject(
    MyHttpClientFactory
  ).createHttpClient(
    environment.urls?.spartaAPI ?? '',
    true,
    ResponseCasingEnum.PascalCase
  );

  search(searchString: string, limit = 50): Observable<ProspectFacilityDto[]> {
    const params = new HttpParams()
      .append('searchString', searchString ?? '')
      .append('take', limit);
    return this.http.get<ProspectFacilityDto[]>(
      `/api/service-request/prospect-facilities`,
      { params }
    );
  }
}
